import React from 'react';

import AppLayout from './layout';
import { Api } from './api';
import { MainForm } from 'Form';
import getInitialUserData from 'Form/utils';

const formName = 'PersecutionFormModel';

const formConfig = {
  form: 'persecution_form',
  formType: 5,
  authorityId: 1,
  initialValues: getInitialUserData(formName),
  formName,
};

const prepareData = (formData) => {
  console.log('harassment message', formData);
  formData.is_agree = 1;

  return formData;
};

export default () => (
  <AppLayout>
    <MainForm
      formConfig={formConfig}
      apiSubmitPromise={Api.submitApplication}
      authorityData={null}
      prepareFormDataCb={prepareData}
      apiResponseOkHandleCb={(resp) => resp}
      apiResponseErrorHandleCb={(resp) => resp}
      full={false}
      isPersecution={true}
    />
  </AppLayout>
);



// WEBPACK FOOTER //
// ./src/apps/harassment-message/app.js